import React from 'react';
import styled from 'styled-components';
import Tooltip from '../../Tooltip';

const InputTextContainer = styled.div`
  input:disabled {
    background: #e8eaeb;
    border: 1px solid #e8eaeb;
  }

  .label {
    font-size: 12px;
    font-family: ${(props) => props.theme.fonts.oswald};
    color: #2b3d54;
    text-transform: uppercase;
    margin-bottom: 7px;
  }

  .labelContainer {
    display: flex;
    flex-direction: row;
  }

  .labelContainer > div {
    margin-left: 4px;
  }

  .tooltipContainer {
    width: 12px;
  }

  input::placeholder {
    color: #233545;
    font-family: ${(props) => props.theme.fonts.sfcompact_italic};
    letter-spacing: -0.6px;
    opacity: 0.3;
    font-size: 14px;
  }

  input {
    height: ${(props) => (props.height ? props.height : '40px')};
    width: calc(100% - 20px) !important;
    padding-left: 20px !important;
    font-size: 12px !important;
    border: ${(props) =>
      props.$error
        ? `1px solid ${props.theme.colors['terra-cotta']}`
        : `1px solid #e8eaeb;`};
    ${(props) =>
      props.$error ? `color:${props.theme.colors['terra-cotta']} ` : undefined};
  }
  ${(props) => props.styles}
`;

const InputText = ({ error, ...props }) => (
  <InputTextContainer
    height={props.height}
    styles={props.styles}
    $error={error}
  >
    {props.label && (
      <div className="labelContainer">
        <p className="label">{props.label}</p>
        {props.tooltip && (
          <div className="tooltipContainer">
            <Tooltip {...props.tooltip} />
          </div>
        )}
      </div>
    )}
    <input
      {...props}
      disabled={props.disabled}
      placeholder={props.placeholder}
      onChange={(e) => props.onChange(e.target.value)}
      value={props.value || ''}
    />
  </InputTextContainer>
);

export default InputText;
